import Popup from "components/Popup/popup";
import style from "./successPopup.module.css";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";

interface SuccessPopupProps {
    isPopupOpen: boolean;
    onClose: () => void;
}

export default function SuccessPopup({ isPopupOpen, onClose }: SuccessPopupProps) {
    const handleClose = () => {
        onClose();
    };

    return (
        <Popup
            title={'Erfolg'}
            submitLabel={""}
            closeLabel={""}
            isWithButton={false}
            isOpen={isPopupOpen}
            onClose={handleClose}
        >
            <div className={style.successMessage}>
                <div className={style.iconContainer} >
                <IoMdCheckmarkCircleOutline className={style.successIcon}/>

                </div>
                <p className={style.successText}>Erfolgreich abgeschlossen!</p>
            </div>
        </Popup>
    );
}
